import React, { useState } from "react";
import { api, errMsg, cleanPhone } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { toast } from "sonner";
import { useOutletContext } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

export default function Contact() {
  const { settings } = useOutletContext();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });

  const submit = async () => {
    try {
      await api.post("/inquiries", { ...form, source: "contact" });
      toast.success("Your inquiry has been submitted.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (e) { toast.error(errMsg(e, "Failed")); }
  };

  return (
    <>
      <PageHeader eyebrow="Say hi" title="Contact us" />
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-8">
        <div className="card-surface p-8">
          <h3 className="font-display text-3xl uppercase mb-6">Get in touch</h3>
          <div className="space-y-4 text-zinc-300">
            {settings?.contact_email && <div className="flex items-center gap-3"><Mail size={18} className="text-red-500"/>{settings.contact_email}</div>}
            {settings?.contact_phone && <div className="flex items-center gap-3"><Phone size={18} className="text-red-500"/>{settings.contact_phone}</div>}
          </div>
        </div>
        <div className="card-surface p-8">
          <h3 className="font-display text-3xl uppercase mb-4">Send a message</h3>
          {["name","email","phone"].map(k => (
            <input key={k} placeholder={k} value={form[k]} onChange={e => setForm({...form,[k]: k === "phone" ? cleanPhone(e.target.value) : e.target.value})} className="w-full bg-black border border-white/10 px-4 py-3 mb-3 focus:border-red-600 outline-none" data-testid={`contact-${k}`} />
          ))}
          <textarea placeholder="Message" value={form.message} onChange={e => setForm({...form,message:e.target.value})} className="w-full bg-black border border-white/10 px-4 py-3 mb-4 focus:border-red-600 outline-none" rows={5} />
          <button onClick={submit} className="btn-red w-full" data-testid="submit-contact">Send message</button>
        </div>
      </div>
    </>
  );
}
